import useResetViewport from '@hooks/canvas/useResetViewport';

const useResetViewportOnNodeDrawer = () => {
  const resetViewPort = useResetViewport();

  return resetViewPort;
};

export default useResetViewportOnNodeDrawer;
